import { Component, Input } from '@angular/core';
import { DocumentService } from '@supoui/core/services/document.service';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-open-invoice-pdf',
    templateUrl: './open-invoice-pdf.component.html',
    styleUrls: ['./open-invoice-pdf.component.scss'],
    standalone: false
})
export class OpenInvoicePdfComponent {
  @Input() invoiceDocumentId: string;

  constructor(private documentService: DocumentService, private logger: NGXLogger) {}

  getAndOpenInvoicePDF(invoiceDocumentId: string): void {
    this.documentService.getDocumentAsPdf(invoiceDocumentId).subscribe(
      result => {
        const url = window.URL.createObjectURL(result);
        window.open(url);
      },
      error => this.logger.debug(error)
    );
  }
}
